import React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import { heightOptions } from "../../constants/warehouse";

export default function LocationHeight({ height, setHeight }) {
  const handleSelect = (type, value) => {
    if (height?.type === type && height?.value === value) {
      setHeight(null, null);
    } else {
      setHeight({ type, value }, false);
    }
  };

  return (
    <Box>
      {heightOptions.map(({ label, type, value }) => (
        <MenuItem key={label} sx={{ fontSize: 14 }} onClick={() => handleSelect(type, value)}>
          <Box my={-1} ml={-1}>
            <Checkbox checked={height?.type === type && height?.value === value} value="" />
          </Box>
          {label}
        </MenuItem>
      ))}
    </Box>
  );
}
